'use client';

import { type MouseEventHandler, forwardRef, useCallback, useContext } from 'react';

import { cx } from '@/styled-system/css';

import { Slot } from '../slot';
import { DrawerRootContext } from './context/drawer-root.context';
import type { DrawerClosePropsInterface } from './types/drawer-close.types';

/**
 * @since 10.22.0
 */
export const DrawerClose = forwardRef<HTMLButtonElement, DrawerClosePropsInterface>(
  (props: DrawerClosePropsInterface, forwardedRef) => {
    const { children, onClick, ...rest } = props;
    const {
      drawer: { onClickClose },
    } = useContext(DrawerRootContext);

    const onClickHandler = useCallback<MouseEventHandler<HTMLButtonElement>>(
      (event) => {
        onClickClose(event);
        onClick?.(event);
      },
      [onClickClose, onClick],
    );

    return (
      <Slot
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Drawer.Close"
        {...rest}
        onClick={onClickHandler}
        className={cx('c11n_drawer__close', rest.className)}
      >
        {children}
      </Slot>
    );
  },
);

DrawerClose.displayName = 'Drawer.Close';
